import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
import { Icon } from './Icon.js';
export function Button({ variant = 'secondary', sm = false, icon, iconRight, children, className, type = 'button', ...rest }) {
    const iconSize = sm ? 13 : 14;
    return (_jsxs("button", { type: type, className: cx('btn', variant, sm && 'sm', className), ...rest, children: [icon && _jsx(Icon, { name: icon, size: iconSize }), children, iconRight && _jsx(Icon, { name: iconRight, size: iconSize })] }));
}
//# sourceMappingURL=Button.js.map